import styled from "styled-components";

export const StyledServiceWorkerWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: ${({ theme }) => theme.whiteTwo};
`;

export const StyledServiceWorkerText = styled.p`
    margin-right: 5px;
`;

export const StyledServiceWorkerButton = styled.button`
    border: none;
    background-color: transparent;
    cursor: pointer;
    padding: 5px;
    color: inherit;
    font-family: inherit;
`;